import Title from "./title";
import Footer from "../privacyPolicyUI/layout/Footer";
import PageLayout from "../../../layoutcontainers/PageLayout";
import { Grid2 } from "@mui/material";
import ScrollToTop from "../privacyPolicyUI/layout/ScrollToTop";
import Navbar from "../privacyPolicyUI/layout/Navbar";
import Section1 from "./section1";
import Section2 from "./section2";
import Section3 from "./section3";
import Section4 from "./section4";
import Section5 from "./section5";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <PageLayout disableFooter showNavbar height="100%" minHeight="100%">
        <Grid2
          container
          spacing={1}
          pt={5}
          pl={10}
          pr={10}
          mt={11}
          sx={{
            "& .MuiTypography-root": {
              textAlign: "justify",
            },
            fontSize: "1.1rem",
          }}
        >
          <Grid2 size={{ xs: 12 }}>
            <Title />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Section1 />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Section2 />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Section3 />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Section4 />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Section5 />
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Footer />
          </Grid2>
        </Grid2>
      </PageLayout>
    </>
  );
};

export default PrivacyPolicy;
